import React, { useState } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Checkbox,
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
    FormGroup
} from '@mui/material';
import {
    Close as CloseIcon
} from '@mui/icons-material';
import api from "@/api";
import {notification} from "antd";
import {getResponseErrorMessage} from "@/utils/api-service";

// Попап для создания новой группы
const CreateGroupPopup = ({ open, onClose, onCreate }) => {
    const [name, setName] = useState('');
    const [preroll, setPreroll] = useState('');
    const [midroll, setMidroll] = useState('');
    const [postroll, setPostroll] = useState('');
    const [isActive, setIsActive] = useState(true);

    const handleSubmit = async () => {
        if (name.trim()) {
            const newGroup = {
                name: name.trim(),
                preroll: preroll.trim(),
                midroll: midroll.trim(),
                postroll: postroll.trim(),
                is_active: isActive,
                domains: []
            };

            try {
                const { data } = await api.adtag.createGroup(newGroup);
                onCreate(data?.data);
                resetForm();
                onClose();
                notification.success({
                    message: "Группа создана!",
                });
            } catch (error) {
                console.error('Ошибка создания группы:', error);
                const messageFormatter = getResponseErrorMessage(error, 'Ошибка при создании группы')
                notification.error({
                    message: messageFormatter
                });
            }
        }
    };

    const resetForm = () => {
        setName('');
        setPreroll('');
        setMidroll('');
        setPostroll('');
        setIsActive(true);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Создать новую группу
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item size={{ xs: 12 }}>
                        <TextField
                            autoFocus
                            fullWidth
                            label="Название группы"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            variant="outlined"
                            required
                        />
                    </Grid>
                    <Grid item size={{ lg: 4 }}>
                        <TextField
                            fullWidth
                            label="Preroll"
                            value={preroll}
                            onChange={(e) => setPreroll(e.target.value)}
                            variant="outlined"
                            required
                        />
                    </Grid>
                    <Grid item size={{ lg: 4 }}>
                        <TextField
                            fullWidth
                            label="Midroll"
                            value={midroll}
                            onChange={(e) => setMidroll(e.target.value)}
                            variant="outlined"
                            required
                        />
                    </Grid>
                    <Grid item size={{ lg: 4 }}>
                        <TextField
                            fullWidth
                            label="Postroll"
                            value={postroll}
                            onChange={(e) => setPostroll(e.target.value)}
                            variant="outlined"
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                    />
                                }
                                label="Группа активна"
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Отмена</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!name.trim() || !preroll.trim() || !midroll.trim() || !postroll.trim()}
                >
                    Создать группу
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateGroupPopup;